<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="cashes"
      :loading="loading"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>CAIXAS</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>

          <v-menu :offset-y="true">
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    color="primary"
                    outlined
                    icon
                    large
                    v-bind="attrs"
                    v-on="{ ...tooltip, ...menu }"
                  >
                    <v-icon>
                      {{ icons.mdiTools }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ferramentas</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item @click="showReportConsolidatedCash()">
                <v-list-item-title>
                  <v-icon>{{ icons.mdiFileChartOutline }}</v-icon> Rel. Consolidado de Caixas
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <v-btn
            v-if="Object.keys(cash).length == 0"
            :loading="loadingBtnCash"
            :disabled="loadingBtnCash"
            color="primary"
            rounded
            class="mb-2 col-3"
            @click="showOpenCash()"
          >
            <v-icon>{{ icons.mdiPlus }} </v-icon>Abrir Novo Caixa
          </v-btn>
          <v-btn
            v-else
            color="secondary"
            rounded
            dark
            class="mb-2 col-3"
            @click="viewOpenCash()"
          >
            Ver Caixa Aberto
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.date_opened="{ item }">
        {{ formatDateTime(item.date_opened) }}
      </template>

      <template v-slot:item.date_closed="{ item }">
        {{ formatDateTime(item.date_closed) }}
      </template>

      <template v-slot:item.initial_cash="{ item }">
        {{ formatMoney(item.initial_cash) }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          v-if="item.open=='not' && item.verified=='not'"
          color="error"
        >
          Fechado
        </v-chip>
        <v-chip
          v-if="item.open=='yes'&& item.verified=='not'"
          color="success"
        >
          Aberto
        </v-chip>
        <v-chip
          v-if="item.open=='not'&& item.verified=='yes'"
          color="info"
        >
          Verificado
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                v-bind="attrs"
                @click="showDetails(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiNoteOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Detalhes</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.verified=='yes'"
                icon
                color="primary"
                class="ml-1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiCheck }}
                </v-icon>
              </v-btn>
            </template>
            <span>Verificado</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.verified=='not'"
                icon
                color="success"
                class="ml-1"
                :disabled="loadingVerifiedId === item.id"
                :loading="loadingVerifiedId === item.id"
                v-bind="attrs"
                @click="handleVerifyClick(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiThumbUpOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Confirmar Verificação</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="secondary"
                class="ml-1"
                v-bind="attrs"
                @click="showReportCash(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiFileChartOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ item.open === 'yes' ? 'Rel. Analítico' : 'Rel. Analítico de Fechamento de Caixa' }}</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogAuthorization"
      width="500px"
    >
      <v-card>
        <BarTitleDialog
          title="Autorizar"
          @close="cancelAuthorization"
        ></BarTitleDialog>
        <v-card-text>
          <v-row no-gutters>
            <v-col>
              <v-text-field
                v-model="authorizationLogin.email"
                :error-messages="authorizationEmailError"
                outlined
                label="Email"
                hide-details="auto"
                @keyup="validateAuthorizationEmail"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="mt-4"
          >
            <v-col>
              <v-text-field
                v-model="authorizationLogin.password"
                :error-messages="authorizationPasswordError"
                outlined
                type="password"
                label="Senha"
                hide-details="auto"
                @keyup="validateAuthorizationPassword"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                x-large
                color="secondary"
                text
                class="mr-4"
                :disabled="authorizationProcessing"
                @click="cancelAuthorization"
              >
                Fechar
              </v-btn>
              <v-btn
                x-large
                color="primary"
                :loading="authorizationProcessing"
                :disabled="authorizationProcessing"
                @click="requestAuthorization"
              >
                Autorizar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG RELATORIO ANALITICO CAIXA  -->

    <v-dialog
      v-model="dialogReportCash"
      width="900px"
    >
      <v-card>
        <BarTitleDialog
          :title="reportCashAnalitical.open === 'yes' ? 'RELATÓRIO ANALÍTICO' : 'REL. FECHAMENTO DE CAIXA'"
          @close="dialogReportCash=false"
        ></BarTitleDialog>
        <v-card-actions>
          <v-row>
            <v-col class="">
              <v-btn
                :loading="loadingReportCash"
                :disabled="loadingReportCash"
                x-large
                color="secondary"
                class="mr-4"
                @click="reportCash(item)"
              >
                <v-icon>{{ icons.mdiFileExportOutline }}</v-icon>exportar
              </v-btn>
            </v-col>
            <v-col class="text-right">
              <v-btn
                x-large
                color="secondary"
                text
                class="mr-4"
                @click="dialogReportCash=false"
              >
                Fechar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text>
          <ReportAnalytical
            v-if="!loadingReportAnalytical"
            :data="dataReportAnalitical"
          />
          <div
            v-else
            class="text-center mt-4"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG RELATORIO CONSOLIDADO DE CAIXA  -->
    <ReportConsolidatedCash v-model="dialogReportConsolidatedCash" />

    <ModalOpenCash v-model="showModalOpenCash" />
  </div>
</template>

<script>
import {
  mdiCheck,
  mdiNoteOutline,
  mdiThumbUpOutline,
  mdiPlus,
  mdiFileChartOutline,
  mdiFileExportOutline,
  mdiTools,
} from '@mdi/js'
import { mapActions } from 'vuex'
import NoDataTable from '@/components/NoDataTable.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import ModalOpenCash from './_components/ModalOpenCash.vue'
import ReportAnalytical from './_components/ReportAnalitical.vue'
import ReportConsolidatedCash from './_components/ReportConsolidatedCash.vue'

export default {
  components: {
    NoDataTable,
    BarTitleDialog,
    ModalOpenCash,
    ReportAnalytical,
    ReportConsolidatedCash,
  },
  data: () => ({
    dialogReportConsolidatedCash: false,

    // dialog cash analitical
    loadingReportCash: false,
    loadingReportAnalytical: false,
    reportCashAnalitical: {},
    dialogReportCash: false,
    dataReportAnalitical: {},

    loadingBtnCash: false,
    showModalOpenCash: false,
    dialogAuthorization: false,
    authorizationProcessing: false,
    authorizationLogin: {
      email: '',
      password: '',
    },
    authorizationEmailError: '',
    authorizationPasswordError: '',
    loadingVerifiedId: null,
    pendingAuthorization: null,
    options: {},
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    loading: false,
    cashes: [],
    cash: {},
    headers: [
      {
        text: 'ID',
        align: 'start',
        sortable: false,
        value: 'id',
      },
      {
        text: 'USUÁRIO',
        align: 'start',
        value: 'user.name',
      },
      {
        text: 'DATA ABERTURA',
        align: 'center',
        value: 'date_opened',
      },
      {
        text: 'DATA ENCERRAMENTO',
        align: 'start',
        value: 'date_closed',
      },
      {
        text: 'CÉLULA TROCO',
        align: 'right',
        value: 'initial_cash',
      },
      {
        text: 'STATUS',
        align: 'center',
        value: 'status',
      },
      {
        text: '',
        align: 'end',
        value: 'actions',
      },
    ],

    search: '',
    icons: {
      mdiNoteOutline,
      mdiCheck,
      mdiThumbUpOutline,
      mdiPlus,
      mdiFileChartOutline,
      mdiFileExportOutline,
      mdiTools,
    },
  }),
  computed: {},
  watch: {
    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    this.initialize()
  },

  methods: {
    ...mapActions('cash_list', ['getCashes', 'storeVerified', 'reportAnalytical', 'viewReportAnalytical']),
    ...mapActions('cash', ['getCash']),
    ...mapActions('authorization', { runAuthorization: 'run' }),
    initialize() {
      // verifica se tem caixa aberto

      this.loadingBtnCash = true
      this.getCash()
        .then(response => {
          this.cash = response.data
        })
        .finally(() => {
          this.loadingBtnCash = false
        })

      const { page, itemsPerPage } = this.options

      const payload = {
        itemsPerPage: itemsPerPage || 10,
        page,
        search: this.search,
      }

      this.loading = true
      this.getCashes(payload)
        .then(response => {
          this.cashes = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => {
          this.loading = false
        })
    },
    showReportConsolidatedCash() {
      this.dialogReportConsolidatedCash = true
    },
    showReportCash(cash) {
      this.dialogReportCash = true
      this.loadingReportAnalytical = true
      this.viewReportAnalytical(cash.id)
        .then(response => {
          this.dataReportAnalitical = response.data
        })
        .finally(() => {
          this.loadingReportAnalytical = false
        })
      this.reportCashAnalitical = cash
    },
    reportCash() {
      this.loadingReportCash = true
      this.reportAnalytical(this.reportCashAnalitical.id)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'report.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
          console.log(response)
        })
        .finally(() => {
          this.loadingReportCash = false
        })
    },
    showDetails(item) {
      this.$router.push(`/cash_list/detalhes/${item.id}`)
    },
    handleVerifyClick(item) {
      this.performVerifyCash(item)
    },
    performVerifyCash(cash, token = null) {
      const cashId = cash.id
      const index = this.cashes.findIndex(item => item.id === cashId)

      this.loadingVerifiedId = cashId

      const payload = {
        cashId,
        token,
      }

      return this.storeVerified(payload)
        .then(response => {
          if (index !== -1) {
            Object.assign(this.cashes[index], response.data)
          }
          this.$toast.success('Salvo com sucesso')
        })
        .catch(error => {
          const status = error?.response?.status

          if (!token && status === 403) {
            this.$toast.error('Você não tem permissão para acessar essa funcionalidade.')
            this.queueAuthorization({ type: 'verify_cash', cashId })

            return Promise.resolve()
          }

          if (status === 422) {
            this.$toast.error(error.response.data || 'Usuário não autorizado')
          } else if (status === 500) {
            this.$toast.error('Erro no servidor')
          }

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingVerifiedId = null
        })
    },
    showOpenCash() {
      this.showModalOpenCash = true
    },
    viewOpenCash() {
      this.$router.push('/cash')
    },
    queueAuthorization(pending) {
      this.pendingAuthorization = pending
      this.dialogAuthorization = true
      this.resetAuthorizationForm()
    },
    requestAuthorization() {
      const isEmailValid = this.validateAuthorizationEmail()
      const isPasswordValid = this.validateAuthorizationPassword()

      if (!isEmailValid || !isPasswordValid) {
        return
      }

      if (!this.pendingAuthorization) {
        this.$toast.error('Nenhuma ação pendente para autorização')

        return
      }

      const credentials = {
        email: this.authorizationLogin.email,
        password: this.authorizationLogin.password,
      }

      // Não valida role - qualquer usuário com a permissão específica pode autorizar
      const validate = loginData => true

      const request = token => {
        if (!token) {
          return Promise.reject(new Error('Token inválido'))
        }

        switch (this.pendingAuthorization.type) {
          case 'verify_cash': {
            const cash = this.cashes.find(item => item.id === this.pendingAuthorization.cashId)
            if (!cash) {
              return Promise.reject(new Error('Caixa não localizado'))
            }

            return this.performVerifyCash(cash, token)
          }
          default:
            return Promise.resolve()
        }
      }

      this.authorizationProcessing = true

      this.runAuthorization({ credentials, validate, request })
        .then(() => {
          this.$toast.success('Usuário autorizado')
          this.dialogAuthorization = false
          this.pendingAuthorization = null
        })
        .catch(error => {
          const message = error?.response?.data?.message || error?.message || 'Usuário não autorizado'
          this.$toast.error(message)
        })
        .finally(() => {
          this.authorizationProcessing = false
          this.resetAuthorizationForm()
        })
    },
    cancelAuthorization() {
      this.dialogAuthorization = false
      this.pendingAuthorization = null
      this.authorizationProcessing = false
      this.resetAuthorizationForm()
    },
    validateAuthorizationEmail() {
      if (!this.authorizationLogin.email) {
        this.authorizationEmailError = 'Email é campo obrigatório'

        return false
      }

      this.authorizationEmailError = ''

      return true
    },
    validateAuthorizationPassword() {
      if (!this.authorizationLogin.password) {
        this.authorizationPasswordError = 'Senha é campo obrigatório'

        return false
      }

      this.authorizationPasswordError = ''

      return true
    },
    resetAuthorizationForm() {
      this.authorizationLogin = {
        email: '',
        password: '',
      }
      this.authorizationEmailError = ''
      this.authorizationPasswordError = ''
    },
    formatMoney(value) {
      if (value != null) {
        return value.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },
    formatDateTime(date) {
      if (date) {
        const result = new Date(date)

        return (
          `${result.toLocaleDateString('pt-BR', {
            timeZone: 'America/Sao_Paulo',
          })
          } ${
            result.toLocaleTimeString('pt-BR')}`
        )
      }
    },
  },
}
</script>

<style scoped>
</style>
